import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/services/api.service';
import { CoreService } from 'src/app/services/core.service';
import { LoaderService } from 'src/app/services/loader.service';
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'app-promotions',
  templateUrl: './promotions.component.html',
  styleUrls: ['./promotions.component.scss']
})
export class PromotionsComponent {
  defImgBanner: string = "assets/logos-nina/nina2_placeholder_banner2.jpg";
  tokenSSLoged:boolean = false
  userData:any = {id:0};
  userPointsData:any = null;
  cookieBranch:any = null;
  promotions:any[] = []

  constructor(private loaderService: LoaderService, private coreService:CoreService, public dialog: MatDialog, public cookies: CookieService, public apiServices: ApiService, public router: Router, private _snackBar: MatSnackBar, public apiUsersServices:UsersService){
    if(cookies.check('Branch')){
      cookies.delete('BranchTemp')
      this.cookieBranch = JSON.parse(this.cookies.get('Branch'))
    }
    else if(cookies.check('BranchTemp')){
      this.cookieBranch = JSON.parse(this.cookies.get('BranchTemp'))
    }

    if(cookies.check('DataPromo')){
      cookies.delete('DataPromo')
    }

    this.tokenSSLoged = this.cookies.check('UL')
    if(this.tokenSSLoged){
      this.getDataProfile()
    }
    else{
      if(this.cookieBranch){
        this.getPromocionesPorSucursalSeleccionada();
      }
      else{
        this.getPromocionesVigentesPorCliente();
      }
    }
  }

  ngOnInit(): void {
    this.coreService.emitSubjet.subscribe(response => {
      if (response.type === 'RefreshLoged') {
        this.tokenSSLoged = this.cookies.check('UL')
        if(this.tokenSSLoged){
          this.getDataProfile()
        }
      }
    })
  }

  login(){
    this.coreService.emitSubjet.next({ type: 'Login', payload: null });
  }

  getDataProfile(){
    this.loaderService.show()
    this.apiUsersServices.me().subscribe({
      next:(value) => {
        if(value.status){
          this.userData = value.data
          this.getPuntosPorUsuario()
          if(this.cookieBranch){
            this.getPromocionesPorSucursalSeleccionada();
          }
          else{
            this.getPromocionesVigentesPorCliente();
          }
        }
        else{
          this.loaderService.hide()
          this.coreService.emitSubjet.next({ type: 'Snackbar', payload: {text: "Hubo un error al procesar tu solicitud"} });
        }
      },
      error:(err) => {
        this.coreService.emitSubjet.next({ type: 'Snackbar', payload: {text: "Hubo un error al procesar tu solicitud"} });
        console.error(err)
        this.loaderService.hide()
      },
    })
  }

  getPromocionesVigentesPorCliente(){
    let data = { 
      token: this.cookies.get('Token'), 
      idCliente:this.userData.id 
    }

    this.apiServices.getPromocionesVigentesPorUsuario(data).subscribe({
      next:(value) => {
        this.promotions = value || [];
      }
    })
  }

  getPromocionesPorSucursalSeleccionada(){
    let data = {
      token: this.cookies.get('Token'),
      idCliente: this.userData.id,
      idSucursal: this.cookieBranch.idSucursal
    }

    this.apiServices.getPromocionesVigentesEnUnaSucursal(data).subscribe({
      next:(value) => {
        this.promotions = value || [];
      },
      error: () => {
        this.coreService.emitSubjet.next({
          type: 'Snackbar',
          payload: {text: "Error al obtener promociones"}
        });
      }
    })
  }

  getPuntosPorUsuario(){
    let data = { token: this.cookies.get('Token'), idCliente:this.userData.id }
    this.apiServices.getPuntosPorUsuario(data).subscribe({
      next:(value) => {
        if(value.length > 0){
          this.userPointsData = value[0]
          this.loaderService.hide()
        }
        else{
          this.coreService.emitSubjet.next({ type: 'Snackbar', payload: {text: "Hubo un error al procesar tu solicitud"} });
        }
        this.loaderService.hide()
      },
      error:(err) => {
        this.coreService.emitSubjet.next({ type: 'Snackbar', payload: {text: "Hubo un error al procesar tu solicitud"} });
        console.error(err)
        this.loaderService.hide()
      },
    })
  }

  promocionSelected(promocion:any){
    if(this.tokenSSLoged === null){
      this.coreService.emitSubjet.next({ type: 'Snackbar', payload: {text: "Inicia sesión para ver los detalles de la promoción"} });
      return;
    }
    else{
      this.cookieBranch = null
      if(this.cookies.check('Branch')){
        this.cookieBranch = JSON.parse(this.cookies.get('Branch'))
      }
      else if(this.cookies.check('BranchTemp')){
        this.cookieBranch = JSON.parse(this.cookies.get('BranchTemp'))
      }
      // console.log("Promoción seleccionada:", promocion);
      this.cookies.set('DataPromo', JSON.stringify({idPromo: promocion.idPromo, idCliente: this.userData.id, tipoPromo: promocion.tipoPromo}), { path: '/' });
      if(this.tokenSSLoged){
        if(this.cookieBranch != null){
          if(promocion.tipoPromo == 1){
            this.router.navigate(['/promo1'])
          }
          else if(promocion.tipoPromo == 2){
            this.router.navigate(['/promo2'])
          }
          else if(promocion.tipoPromo == 3){
            this.router.navigate(['/promo3'])
          }
          else if(promocion.tipoPromo == 4){
            this.router.navigate(['/promo4'])
          }
          else if(promocion.tipoPromo == 5){
            this.router.navigate(['/promo5'])
          }
          else if(promocion.tipoPromo == 6){
            this.router.navigate(['/promo6'])
          }
          else{
            this.coreService.emitSubjet.next({ type: 'Snackbar', payload: {text: "Tipo de promoción no reconocido"} });
          }
        }
        else{
          this.coreService.emitSubjet.next({ type: 'ShippingType', payload: { promotion: promocion , user: this.userData } });
        }
      }
      else{
        this.coreService.emitSubjet.next({ type: 'LoginExternal', payload: null });
      }
    }
  }
}
